import {
   SET_CURRENT_USER,
   CLEAR_CURRENT_USER,
   SET_USER_DATA,
   SET_TREKS,
   UPDATE_USER,
} from "./Auth.actions";

export const initialState = {
   isAuthenticated: false,
   user: null,
   token: null,
   data: null,
   treks: null,
};

const authReducer = (state = initialState, action) => {
   switch (action.type) {
      case SET_CURRENT_USER:
         return {
            ...state,
            isAuthenticated: true,
            user: action.payload.user,
            token: action.payload.token,
         };
      case CLEAR_CURRENT_USER:
         return {
            // ...state,
            isAuthenticated: false,
            user: null,
            token: null,
            treks: null,
         };
      case SET_USER_DATA:
         return {
            ...state,
            data: action.payload.user,
            treks: action.payload.treks,
         };
      case SET_TREKS:
         return {
            ...state,
            treks: action.payload,
         };
      case UPDATE_USER:
         return {
            ...state,
            data: action.payload,
         };
      default:
         return state;
   }
};

export default authReducer;
